import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

interface DialogContent {
    type: 'unattended' | 'payer-attended';
    paymentRequest: any;
}

@Component({
    selector: 'confirm-dialog',
    styleUrl: 'confirm-dialog.component.scss',
    templateUrl: 'confirm-dialog.component.html',
    standalone: false
})
export class ConfirmDialogComponent {
    constructor(
        public dialogRef: MatDialogRef<ConfirmDialogComponent, 'yes'>,
        @Inject(MAT_DIALOG_DATA) public data: DialogContent
    ) {}

    onYesClick(): void {
        this.dialogRef.close('yes');
    }
}
